exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".task-wrapper .ibox-title {\n    padding:15px;\n}\n\n.task-wrapper .ibox-content {\n    padding:15px 7px;\n}\n.task-wrapper .task-content {\n    padding:0px 7px;\n    margin: 15px 0px;\n}\n.form-margin-top {\n    margin-top:25px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/general-tasks/public/assets/css/general-tasks.css
// module id = 81
// module chunks = 0